import { Button, message, Modal } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import WarehouseService from "../../services/Warehouses/WarehouseService";
import { useState } from "react";
import ConfirmDeleteButton from "../../common/actions/ConfirmDeleteButton";

const WarehouseReceivingZoneDelete = ({ warehouseId, id, handleCancel }) => {
  const queryClient = useQueryClient();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { mutate } = useMutation({
    mutationFn: async () => await WarehouseService.deleteReceivingZone(warehouseId, id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [warehouseId, "receivingZones"] });
      await queryClient.invalidateQueries({ queryKey: [warehouseId, "docks"] });
      handleCancel();
      message.success("Receiving zone deleted successfully!");
    },
    onError: async (error) => {
      setIsModalOpen(false);
      message.error(`Failed to delete receiving zone. ${error?.response?.data?.message}, Please try again.`);
    },
  });

  return (
    <>
      <ConfirmDeleteButton  title="Are you sure you want to delete this zone?" onConfirm={mutate} />
    </>
  );
};

export default WarehouseReceivingZoneDelete;